import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import { getS3Object } from '../utils/myKadImg';
import { authenticateCurrentUser } from '../redux/authenticate/actions';
import * as selectors from '../redux/selectors';
import * as profileStatus from '../redux/profile/status';
import { getProfile } from '../redux/profile/actions';
import { flashMessage } from '../redux/flash/actions';

import Date from '../components/Date';
import Image from '../components/Image';
import Value from '../components/Value';
import Identity from '../components/Identity';

import refresh from '../assets/icons/ico_refresh.png';

import './SingleProfile.css';

class SingleProfile extends Component {
  static propTypes = {
    profile: PropTypes.array,
  }
  static defaultProps = {
    // profile
  }

  static mapStateToProps = state => ({
    profile: selectors.getProfile(state),
  })

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      images: [],
      userID: '',
      profileID: '',
      profile: props.profile,
    }
  }

  async componentDidMount() {
    await this.start();
    await this.loadImages();
    this.getProfile();
  }

  componentWillUnmount() {
    this.loadImages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile !== this.props.profile) {
      this.setState({ profile: nextProps.profile });
    }
    if (this.props.profile ||
      this.props.profile.icFront !== nextProps.profile.icFront ||
      this.props.profile.icBack !== nextProps.profile.icBack
    ) {
      this.loadImages();
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async start() {
    const { match } = this.props;
    await this.setStateAsync({ 
      profileID: this.getProfileId(match.params.id),
      userID: this.getUserId(match.params.id),
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { profile } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      if (profile && profile.icFront) {
        runImages.push(getS3Object(profile.icFront, 'icFront', token));
      }
      if (profile && profile.icBack) {
        runImages.push(getS3Object(profile.icBack, 'icBack', token));
      }
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  getProfileId = (str) => {
    return str.substring(
      str.indexOf('=') + 1,
      str.indexOf('&')
    );
  }
  getUserId = (str) => {
      return str.split('&uid=')[1];
    }

  getProfile = async () => {
    const { store } = this.context;
    const body = {
      userID: this.state.userID,
      profileID: this.state.profileID,
    };
    const res = await store.dispatch(getProfile(body));
    if (res > profileStatus.PROFILE_STATUS_OK) {
      store.dispatch(flashMessage('Fail to get profile', 'error'));
      return;
    }
  }

  isComplete = (type, obj) => {
    if (type === 'verify') {
      if (obj) {
        return 'Verified';
      }
      return 'Not Verified';
    }

    if (type === 'complete') {
      if (obj) {
        return 'Completed';
      }
      return 'Not Completed';
    }
    return '';
  }

  hasIssue = (obj) => {
    if (obj) {
      return 'Yes';
    }
    return 'No';
  }

  handleRefresh = async () => {
    const { store } = this.context;
    const body = {
      userID: this.state.userID,
      profileID: this.state.profileID,
    };
    const res = await store.dispatch(getProfile(body));
    if (res > profileStatus.PROFILE_STATUS_OK) {
      store.dispatch(flashMessage('Fail to refresh', 'error'));
      return;
    }
    store.dispatch(flashMessage('Refresh success', 'notify'));
  }

  render() {
    const { profile } = this.props;
    const uploadedICFront = this.state.images.find(i => i.name === 'icFront');
    const uploadedICBack = this.state.images.find(i => i.name === 'icBack');
    return (
      <div className="Profile">
        <h2 className="header">
          Profile Information:
        <button onClick={this.handleRefresh} className="iconBtn">
          <img src={refresh} alt="refresh" />
        </button>
        </h2>
        <div className="box">
          <Row>
            <Col xs={12}>
              <p><b>Created at:</b> <Date>{profile.createdAt}</Date></p>
              <p><b>Last updated at:</b> <Date>{profile.lastUpdated}</Date></p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h4><b>User Details</b></h4>
              <div className="colDoubleSection">
                <span>
                  <p><b>Name:</b> {profile.name}</p>
                  <p><b>NRIC:</b> <Identity type={1} identity={`${profile.nric}`} /></p>
                </span>  
                <span>
                  <p><b>Email:</b> {profile.email}</p>
                  <p><b>Mobile:</b> {profile.mobile}</p>
                </span>  
              </div>  
            </Col>
            <Col xs={7}>
              <p><b>MyKad</b></p>
              {
                profile && uploadedICFront ?
                <Image
                  inline
                  src={uploadedICFront ? uploadedICFront.body : null}
                  alt="IC Front"
                  loading={this.state.loadingImages}
                  fullWidth
                />
                : 'No Upload IC Front'
              }
              {
                profile && uploadedICBack ?
                <Image
                  inline
                  src={uploadedICBack ? uploadedICBack.body : null}
                  alt="IC Back"
                  loading={this.state.loadingImages}
                  fullWidth
                  />
                : 'No Upload IC Back'
              }
            </Col>
            <Col xs={5}>
              <p><b>Status</b></p>
              <p><b>New User:</b> {profile.isNew ? 'Yes' : 'No'}</p>
              <p><b>Mobile Verification:</b> {this.isComplete('verify', profile.mobileVerified)}</p>
              <p><b>IC Verification:</b> {this.isComplete('verify', profile.icVerified)}</p>
              <p><b>Income Completed:</b> {this.isComplete('complete', profile.incomeCompleted)}</p>
              <p><b>Check Completed:</b> {this.isComplete('complete', profile.checkCompleted)}</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h4><b>IDs</b></h4>
              <p><b>User ID:</b> <code>{profile.userID}</code></p>
              <p><b>Profile ID:</b> <code>{profile.profileID}</code></p>
              <p><b>OCR ID:</b> <code>{profile.ocrID}</code></p>
              <p><b>Income ID:</b> <code>{profile.incomeID}</code></p>
              <p><b>Check ID:</b> <code>{profile.checkID}</code></p>
            </Col>
          </Row>  
          <Row>
            <Col xs={3}>
              <p><b>Counters</b></p>
              <p><code>{profile.smsCount}</code>&nbsp;<b>TAC PIN Request Count(s)</b></p>
              <p><code>{profile.ocrCount}</code>&nbsp;<b>IC Verification Count(s)</b></p>
              <p><code>{profile.updateIncomeCount}</code>&nbsp;<b>Update Income Count(s)</b></p>
              <p><code>{profile.leadSubmitCount}</code>&nbsp;<b>Total Lead Submitted</b></p>
              <p><code>{profile.rerunCount}</code>&nbsp;<b>Credit Check Request Count(s)</b></p>
            </Col>
            <Col xs={3}>
              <p><b>Retries</b></p>
              <p><code>{profile.smsRetry}</code> <b>TAC PIN Retry</b></p>
              <p><code>{profile.ocrRetry}</code> <b>IC Retry</b></p>
            </Col>
            <Col xs={3}>
              <p><b>Has issues?</b></p>
              <p><b>TAC PIN Request Issue:</b> {this.hasIssue(profile.hassmsIssue)}</p>
              <p><b>IC Upload Issue:</b> {this.hasIssue(profile.hasOCRIssue)}</p>
              <p><b>Check Issue:</b> {this.hasIssue(profile.hasCheckIssue)}</p>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <p><b>Score:</b> <Value percent>{profile.dsrPercent}</Value></p>
            </Col>
            <Col xs={3}>
              <p><b>Income Type:</b> {profile.incomeType}</p>
              <p><b>Income:</b> <Value money>{profile.incomeNetCents}</Value></p>
            </Col>
          </Row>        
        </div>
      </div>
    );
  }
}

export default connect(SingleProfile.mapStateToProps)(SingleProfile);



// WEBPACK FOOTER //
// ./src/containers/SingleProfile.jsx